import { resolvePrimaryRole } from './rolePrecedence';
export function websiteAccountPath(user: Parameters<typeof resolvePrimaryRole>[0], tenantPath: string): string {
 const role = resolvePrimaryRole(user);
 if (!role || !['landlord','agent','agency'].includes(role)) return tenantPath;
 const paths: Record<string,string> = {
  '/tenant/dashboard':'/dashboard','/tenant/profile':'/profile',
  '/tenant/dashboard?tab=conversations':'/conversations','/tenant/dashboard?tab=enquiries':'/leads',
  '/tenant/dashboard?tab=profile':'/kyc','/tenant/verification':'/kyc',
 };
 return `/${role}${paths[tenantPath] ?? '/dashboard'}`;
}
